// The shorter checkout for people who come from an ad page (/lp/..., whose
// buttons link to /order/type?flow=ad: tools/ad-pages.data.js). Paid visits
// were leaving before uploading anything, so the upload comes first
// (Order/OrderDocuments.js), "Who is asking" doesn't hold up the next step
// (Order/OrderOptions.js), and someone we know clicked an ad isn't asked how
// they heard about us (Order/OrderContact.js). Everyone else's checkout stays
// as it was.
//
// Kept for the visit (sessionStorage), so it still applies after a reload or
// Back and forward. With blocked storage they just get the usual checkout.

const PARAM = 'flow';
const AD_FLOW = 'ad';
const STORAGE_KEY = 'checkoutFlow';

export const inAdFlow = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === AD_FLOW;
  } catch (e) {
    return false;
  }
};

// Clarity (public/index.html) keeps these visits apart when reading the results.
const tellClarity = () => {
  try {
    if (typeof window.clarity === 'function') {
      window.clarity('set', 'flow', AD_FLOW);
    }
  } catch (e) {
    // Never in the customer's way.
  }
};

// Called once on load (App.js). Remembers ?flow=ad and takes it out of the
// address, leaving every other parameter and the hash as they were.
export const captureAdFlowFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get(PARAM) === AD_FLOW) {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, AD_FLOW);
      } catch (e) {
        // Blocked storage: the usual checkout, as above.
      }
      params.delete(PARAM);
      const search = params.toString();
      window.history.replaceState(window.history.state, '', `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`);
    }
    if (inAdFlow()) {
      tellClarity();
    }
  } catch (e) {
    // Never in the customer's way.
  }
};
